module.exports = __webpack_public_path__ + "static/under-construction.c08a8a83.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/under-construction.png
// module id = 70
// module chunks = 168707334958949